import * as React from 'react';
import './warningWithConfirmation.module.scss';

export const WarningHeader = ({ children }) => <div styleName="warning-header">{children}</div>;

export const WarningBody = ({ children }) => <div styleName="warning-body">{children}</div>;

export const CheckBoxWithLabel = ({ id, checked, onCheck, label, className = undefined, styleName = undefined }) => (
    <div styleName="checkbox-with-label" className={className}>
        <input id={id} type="checkbox" checked={checked} onChange={(e) => onCheck(e.target.checked)} />
        <label htmlFor={id}>{label}</label>
    </div>
);

type Props = {
    id: string;
    header: any;
    body: any;
    confirmed: boolean;
    onConfirmationChange: (nextValue: boolean) => any;
};
export const WarningWithConfirmation = ({ id, header, body, confirmed, onConfirmationChange }: Props) => {
    return (
        <div styleName="warning-with-confirmation">
            <WarningHeader>{header}</WarningHeader>
            <WarningBody>{body}</WarningBody>
            <CheckBoxWithLabel
                id={id}
                label={'上記の注意点を十分に理解しました'}
                checked={confirmed}
                onCheck={onConfirmationChange}
            />
        </div>
    );
};
